

export function getCookie(cookieName: string) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === cookieName) {
            return decodeURIComponent(value);
        }
    }
    return undefined;
}

export function setCookie(cookieName: string, value: string, maxAge: number) {

    document.cookie = `${cookieName}=${value}; max-age=${maxAge}; path=/`;
}

export function deleteCookie(cookieName: string) {
    // Delete a cookie by setting its expiration date in the past.
    document.cookie = `${cookieName}=; max-age=0; path=/;`;
}
